export const FETCH_COUNTRIES = "FETCH_COUNTRIES";
export const FETCH_COUNTRIES_PENDING = "FETCH_COUNTRIES_PENDING";
export const FETCH_COUNTRIES_REJECTED = "FETCH_COUNTRIES_REJECTED";
export const FETCH_COUNTRIES_FULFILLED = "FETCH_COUNTRIES_FULFILLED";
